// ── Shopify Settings Bridge ──────────────────────────────────────────────────
// Reads settings injected by theme.liquid into window.AYOPSYCHOO
// Falls back to defaults when running standalone HTML
const _S = window.AYOPSYCHOO || {};
const METAL_API_KEY   = _S.metalApiKey   || 'YOUR_KEY_HERE';
const GOLD_GRAMS_SET  = _S.goldGrams     || 4.5;
const SILVER_GRAMS_SET= _S.silverGrams   || 8;

const cursor=document.getElementById('cursor'),ring=document.getElementById('ring');
  let mx=0,my=0,rx=0,ry=0;
  document.addEventListener('mousemove',e=>{mx=e.clientX;my=e.clientY;cursor.style.left=mx+'px';cursor.style.top=my+'px';});
  (function animRing(){rx+=(mx-rx)*.1;ry+=(my-ry)*.1;ring.style.left=rx+'px';ring.style.top=ry+'px';requestAnimationFrame(animRing);})();
  document.querySelectorAll('a,button,.coll-card,.step,.testi-card').forEach(el=>{
    el.addEventListener('mouseenter',()=>{cursor.style.width='18px';cursor.style.height='18px';ring.style.width='54px';ring.style.height='54px';});
    el.addEventListener('mouseleave',()=>{cursor.style.width='10px';cursor.style.height='10px';ring.style.width='34px';ring.style.height='34px';});
  });
  const obs=new IntersectionObserver(entries=>entries.forEach(e=>{if(e.isIntersecting){e.target.style.opacity='1';e.target.style.transform='translateY(0)';}}),{threshold:.08});
  document.querySelectorAll('.step,.testi-card,.coll-card').forEach((el,i)=>{el.style.opacity='0';el.style.transform='translateY(34px)';el.style.transition=`opacity .55s ${i*.07}s,transform .55s ${i*.07}s`;obs.observe(el);});

// ─── METAL PRICE ENGINE ───────────────────────────────────────────────────────
// Get free API key at metalpriceapi.com (no credit card needed)
// API key from Shopify settings (see window.AYOPSYCHOO above)

const GCFG = { gramsPerSet:GOLD_GRAMS_SET, laborBase:120, markup:1.45 };
const SCFG = { gramsPerSet:SILVER_GRAMS_SET,   laborBase:55,  markup:1.50 };
const OZG  = 1/31.1035;

let gPrices = { goldOz:3150, silverOz:32.5 };

async function fetchMetalPrices() {
  if (METAL_API_KEY === 'YOUR_KEY_HERE' || !METAL_API_KEY) {
    // Daily-seeded variance simulates live movement without API key
    const seed = new Date().toDateString().split('').reduce((a,c)=>a+c.charCodeAt(0),0);
    const prev = {...gPrices};
    gPrices.goldOz   = 3050 + (seed % 300);
    gPrices.silverOz = 29   + (seed % 10);
    renderTicker(gPrices, prev);
    updateCardPrices();
    return;
  }
  try {
    const r = await fetch('https://api.metalpriceapi.com/v1/latest?api_key='+METAL_API_KEY+'&base=USD&currencies=XAU,XAG');
    const d = await r.json();
    if (d.success) {
      const prev = {...gPrices};
      gPrices.goldOz   = 1/d.rates.XAU;
      gPrices.silverOz = 1/d.rates.XAG;
      localStorage.setItem('ayoMetals', JSON.stringify({prices:gPrices, ts:Date.now()}));
      renderTicker(gPrices, prev);
      updateCardPrices();
    }
  } catch(e) {
    renderTicker(gPrices, null);
    updateCardPrices();
  }
}

function renderTicker(p, prev) {
  const fmt = n => '$'+n.toLocaleString('en-US',{minimumFractionDigits:2,maximumFractionDigits:2});
  const g = id => document.getElementById(id);
  if(g('goldPrice'))   g('goldPrice').textContent   = fmt(p.goldOz);
  if(g('silverPrice')) g('silverPrice').textContent = fmt(p.silverOz);
  if(prev) {
    const setChg = (eid, cur, old) => {
      const diff = cur-old, pct=((diff/old)*100).toFixed(2);
      const el = document.getElementById(eid);
      if(el){ el.textContent=(diff>=0?'▲':'▼')+' '+Math.abs(pct)+'%'; el.className='ticker-change '+(diff>=0?'up':'down'); }
    };
    setChg('goldChange',   p.goldOz,   prev.goldOz);
    setChg('silverChange', p.silverOz, prev.silverOz);
  }
}

function calcPrice(metal, cat) {
  const cfg  = metal==='silver'?SCFG:GCFG;
  const spot = metal==='silver'?gPrices.silverOz:gPrices.goldOz;
  const base = (spot*OZG*cfg.gramsPerSet*cfg.markup)+cfg.laborBase;
  const mults = {'10k':0.42,'14k':0.58,'18k':1.0,'silver':1.0,'diamond':3.8,'rose':1.1};
  return Math.ceil(base*(mults[cat]||1)/5)*5;
}

function updateCardPrices() {
  [['price-solid-gold','gold','14k'],['price-sterling','silver','silver'],['price-iced','gold','diamond'],['price-rose','gold','rose']].forEach(([id,m,c])=>{
    const el=document.getElementById(id);
    if(el){ const p=calcPrice(m,c); el.innerHTML='<span class=\"live-dot\"></span>From $'+p.toLocaleString()+' <small style=\"opacity:.55;font-size:9px;font-family:IBM Plex Mono,monospace\">LIVE</small>'; }
  });
}

// ─── EMAIL CAPTURE ────────────────────────────────────────────────────────────
function handleCapture() {
  const g  = id => document.getElementById(id);
  const first = g('capFirst').value.trim();
  const email = g('capEmail').value.trim();
  if(!first){ shakeField('capFirst'); return; }
  if(!email||!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email)){ shakeField('capEmail'); return; }
  const btn = g('captureSubmit');
  btn.querySelector('.submit-text').style.display='none';
  btn.querySelector('.submit-loading').style.display='inline';
  btn.disabled=true;
  const leads=JSON.parse(localStorage.getItem('ayo_leads')||'[]');
  leads.push({id:Date.now(),first,last:g('capLast').value.trim(),email,phone:g('capPhone').value.trim(),interest:g('capInterest').value,sms:g('capSMS').checked,gold_price:gPrices.goldOz,silver_price:gPrices.silverOz,ts:new Date().toISOString()});
  localStorage.setItem('ayo_leads',JSON.stringify(leads));
  const cnt=g('subCount'); if(cnt) cnt.textContent=(parseInt(cnt.textContent.replace(/,/g,''))+1).toLocaleString();
  setTimeout(()=>{ g('captureForm').style.display='none'; g('captureSuccess').style.display='block'; },1000);
}

function shakeField(id) {
  const el=document.getElementById(id);
  if(!el) return;
  el.style.borderColor='#FF4444';
  el.style.animation='shake 0.4s ease';
  setTimeout(()=>{el.style.borderColor='';el.style.animation='';},500);
}

document.addEventListener('DOMContentLoaded',()=>{ fetchMetalPrices(); setInterval(fetchMetalPrices,3600000); });